import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "close",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_866_25284",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 30,
			height: 30,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 30,
				height: 30,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_866_25284)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "close_2",
				d: "M8 24.75L5.25 22L12.25 15L5.25 8L8 5.25L15 12.25L22 5.25L24.75 8L17.75 15L24.75 22L22 24.75L15 17.75L8 24.75Z",
				fill: "#1D2D58"
			})
		})]
	})
});
export default SvgClose;
